import styles from './Lead.module.css';

export interface LeadProps {
  title: string;
  children: any;
}

export const Lead = (props: LeadProps) => {
  return (
    <section className={styles.lead}>
      <h1 className={styles.title}>{props.title}</h1>
      <div className={styles.body}>{props.children}</div>
    </section>
  );
};
